import { Fragment } from 'react';

import type { TextRange } from './match';

/**
 * QF-01 — text with its matched parts marked, as TEXT: `<mark>` elements
 * around plain text nodes, never markup built from a string, so a title can
 * never become HTML.
 *
 * Drawn with what R-050 already has: a Plum-tint background AND an underline
 * (colour is never the only cue), in the text's own weight and colour (no
 * reflow, and an Arabic word is never re-shaped by a weight change). The
 * ranges come from `match.ts` / `goto.ts`, Arabic ones already widened to
 * whole words.
 */
export function Highlight({ text, ranges }: { text: string; ranges: readonly TextRange[] }) {
  if (ranges.length === 0) return <>{text}</>;

  const parts: { text: string; marked: boolean }[] = [];
  let at = 0;

  for (const [from, to] of ranges) {
    if (from > at) parts.push({ text: text.slice(at, from), marked: false });
    parts.push({ text: text.slice(from, to), marked: true });
    at = to;
  }

  if (at < text.length) parts.push({ text: text.slice(at), marked: false });

  return (
    <>
      {parts.map((part, index) =>
        part.marked ? (
          <mark
            key={index}
            data-quickfind-match=""
            className="rounded-[2px] bg-brand-100 text-inherit underline decoration-brand-500 decoration-1 underline-offset-[3px]"
          >
            {part.text}
          </mark>
        ) : (
          <Fragment key={index}>{part.text}</Fragment>
        ),
      )}
    </>
  );
}
